<template>
<div class="almacen-list">
    <h1 class="titulo">TINAS</h1>
    <div class="lcards">
      <div v-for="(tina, i) in tinas" class="card-sum">
          <div class="tina">
              <div class="tina-content">
                <table style="width:100%">
                  <tr>
                    <td style="width:30%"> <p class="tina-nombre"> {{ tina.nombre }} </p></td>
                    <td style="width:70%"> <p class="tina-producto" v-bind:style="{background : tina.color}"> {{ tina.producto }} </p></td>
                  </tr>
                </table>

              <div class="tina-panel">
                  <p class="tina-total">  {{Number(tina.cantidad).toLocaleString('en', options) }} </p>

              </div>

              </div>
          </div>
      </div>
    </div>
</div>
</template>

<script>
export default {
  name: "Tinas",
  data() {
    return {
     tinas: []
  }
},
methods: {

  },
  created() {
 this.$http.get("https://senfucen.firebaseio.com/tinas2.json").then(res => {
      this.tinas = res.data;
      //this.lotes = this.langostas["0"];
      console.log(this.tinas);
      //alert(this.lotes[0].lote);
      });
  }
}
</script>

<style scoped>
</style>
